import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?
                    <section className="mb-20">
                        <div className="container mx-auto position-relative relative mb-6 max-sm:px-4">
                            <img src={awardingData.awarding_photo} className="block w-full rounded-t-2xl sm:rounded-b-2xl"/>
                            <div
                                className="lg:absolute bottom-9 left-0 right-0 m-auto text-center  w-full lg:w-4/5 lg:w-3/5 px-5 sm:px-10 lg:px-20 py-12 bg-[#5DABF9]/90 rounded-b-2xl sm:rounded-t-2xl">
                                <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="sm:text-4xl text-2xl mb-4">{awardingData.awarding_title}</h2></ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp"><div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(awardingData.awarding_text, {sanitize: true})}} /></ScrollAnimation>
                            </div>
                        </div>
                    </section> : ''
            }
        </>
    )
}

export default Awarding